<template>
    <el-dialog custom-class="file-dialog" v-if="file.path" :title="file.name || '文件名'" :close-on-click-modal="false"
        :visible="dialogVisible" @close="$emit('closeFile')">

        <div class="file-dialog-content">
            <iframe v-if="file.type == 'docx' || file.type == 'doc'" width="100%" height="100%"
                :src="'https://view.officeapps.live.com/op/view.aspx?src=' + src" frameborder="0">
            </iframe>
            <embed v-else width="100%" height="100%" :src="src" :type="type">
        </div>
        <!-- <div class="file-dialog-download">
            <div class="file-dialog-button">下载</div>
        </div> -->
    </el-dialog>
</template>

<script>
    //文档的类型
    const MIME = {
        pdf: 'application/pdf',
        // html: 'text/html',
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        // gif: 'image/gif',
        // svg: 'image/svg+xml',
        doc: 'application/msword',
        docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        png: 'image/png'
    }
    export default {
        props: {
            dialogVisible: {
                type: Boolean,
            },
            file: Object,
        },
        computed: {
            type: function () {
                return MIME[this.file.type];
            },
            src: function () {
                let encode = encodeURI(this.file.path)
                // console.log(encode,this.file.path)
                if (this.file.type == 'pdf') {
                    let filename = encode.split('/').slice(-6).join('/')
                    return 'https://local.vrmaker.vip:1443/' + filename
                } else {
                    return encode
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .file-dialog-content {
        .h(701);
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    }

    .file-dialog-download {
        .h(80);
        display: flex;
        justify-content: center;
        align-items: center;

        .file-dialog-button {
            .w(72);
            .h(32);
            display: flex;
            justify-content: center;
            align-items: center;
            background: #0D94FF;
            border-radius: 4px;
            color: #FFF;
            cursor: pointer;
        }
    }
</style>